
import { Matrix, WorkCom } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { Model } from '../../model/model';

/** 
 * point d'entrée générique pour les chargements des matrices
 * va passer par le service :
 * - chargement du pool local
 * - comparaison des versions avec remote
 * - téléchargement si nécessaire
 * - merge
 * - alimentation du modèle
 */
export class MatrixCall extends WizCommand<any> {

  protected model: Model = null;

  constructor(model: Model, pCallback: Function = null) {
    super();
    this.model = model;
    if(pCallback) {
      this._callback = pCallback;
    }
  }

  private _callback: Function = this.voidCallback.bind(this); // retour par défaut pour traçabilité debug

  public wizExecute(): Promise<any> {
    return new Promise((resolve, reject) => {
      const backFromFind = (mat: Matrix[]) => {
        this._callback(mat);
        resolve(mat);
      };

      this.model.matrixSyncService.find(backFromFind);
    });
  }

  public voidCallback(result: any): void {
  }
}
